module.exports = __webpack_public_path__ + "media/images/top/feature/top-features-4-f91b0c8bf0ba898df07d1ab128f10b66.png";